// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"364":"view-RegPage-vue","490":"view-LogIn-vue","831":"view-PasswordReset-vue"}[chunkId] + "." + {"364":"fcf981d3","490":"c9916037","831":"8509ac2c"}[chunkId] + ".js";
};